module.exports = __webpack_public_path__ + "static/media/pdf-llm.b6eda890.png";